exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-btn[data-v-48dd1a71] {\n  padding: 10px 20px;\n}\n.info[data-v-48dd1a71] {\n  display: flex;\n}\n.tabs[data-v-48dd1a71] {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin: 0 auto;\n  padding: 30px 0 10px 0;\n}\n.tabs button[data-v-48dd1a71] {\n  min-width: calc(18% - 10px) !important;\n  background-color: #e6e6e6;\n  color: #4b4b4b;\n}\n.active[data-v-48dd1a71] {\n  background-color: #34458D !important;\n  color: #fff !important;\n}\n.table-btn[data-v-48dd1a71] {\n  min-width: 0;\n}\n.info--desc[data-v-48dd1a71] {\n  flex-direction: column;\n  text-align: left;\n}\n\n", ""]);

// exports
